import errors from './errors';
import themes from './theme';
import features from './features';
import common from '../common';
import { CAI_MATERIAL } from '@cai/material';

export default {
  ...common,
  mobileTicket: 'Mobilus bilietas',
  ...features,
  save: 'Išsaugoti',
  username: 'Vartotojo vardas',
  password: 'Slaptažodis',
  login: 'Prisijungti',
  required: 'Reikalingas',
  light: 'Šviesa',
  dark: 'Tamsus',
  rememberMe: 'Prisimink mane',
  eula: 'EULA',
  copyright: `© {year} - Command Alkon, Inc.`,
  termsAndConditions: 'Taisyklės ir sąlygos',
  privacyPolicy: 'Privatumo politika',
  customer: 'Klientas',
  project: 'Projektas',
  isBillable: 'Atsiskaitoma',
  dispatchDateTime: 'Data',
  orderId: 'Užsakyti',
  ticketId: 'Bilietas',
  location: 'Vieta',
  vehicleTypeName: 'Transporto priemonė',
  product: 'Produktas',
  products: 'Produktas',
  salesTax: 'Pardavimo mokestis',
  totalPrice: 'Iš viso',
  extendedPrice: 'Išor',
  destination: 'Paskirties vieta',
  productId: 'Produktas',
  statusCode: 'Būsena',
  vehicleTypeId: 'Transporto priemonės tipo ID',
  locationId: 'Vietos ID',
  customerId: 'Kliento ID',
  projectId: 'Projekto ID',
  dispatchTime: 'Laikas',
  showAll: 'Rodyti viską',
  hideAll: 'Slėpti viską',
  undoChanges: 'Anuliuoti pakeitimus',
  resetColumns: 'Iš naujo nustatyti stulpelius',
  displayRowCount: `Rodoma {count, plural, 
    =0 {0 eilučių} 
    one {# eilutė} 
    other {# eilučių} 
  }`,
  columnFilters: 'Stulpelių filtrai',
  visible: 'Matoma',
  hidden: 'Paslėpta',
  itemDetail: 'Prekės detalė',
  quantity: 'Kiekis',
  quantityMaxWaterToAdd: `Kiekis (didžiausias vandens kiekis: {maxWaterQuantity})`,
  unloadingMethod: 'Iškrovimo būdas',
  time: 'Laikas',
  eventStatus: 'Būsena',
  MTQ_abbr: 'm\u00B3',
  EA_abbr: 'ea',
  LTR_abbr: 'L',
  YDQ_abbr: 'y³',
  GLL_abbr: 'gal',
  MTQ_text: 'Kubiniai metrai',
  M3_text: 'Kubiniai metrai',
  EA_text: 'Kiekvienas',
  LTR_text: 'Litrų',
  YDQ_text: 'Kubiniai kiemai',
  GLL_text: 'Galonai',
  ACR_text: 'Akrų',
  HUR_text: 'Valanda',
  INH_text: 'Coliai',
  FOT_text: 'Pėda',
  YRD_text: 'Kiemas',
  MMT_text: 'Milimetras',
  CMT_text: 'centimetras',
  MTR_text: 'Metras',
  SMI_text: 'Mylia (statute mylia)',
  KMT_text: 'Kilometras',
  INK_text: 'Kvadratinis colis',
  FTK_text: 'Kvadratinė pėda',
  YDK_text: 'Kvadratinis kiemas',
  MIK_text: 'Kvadratinė mylia',
  CMK_text: 'Kvadratinis centimetras',
  MTK_text: 'Kvadratinis metras',
  KMK_text: 'Kvadratinis kilometras',
  INQ_text: 'Kubinis colis',
  MMQ_text: 'Kubinis milimetras',
  FTQ_text: 'Kubinė pėda',
  CMQ_text: 'Kubinis centimetras',
  OZA_text: 'Skysčio uncija',
  PT_text: 'Pintas',
  QT_text: 'Kvart',
  MLT_text: 'Mililitras',
  ONZ_text: 'Uncija',
  LBR_text: 'Svaras',
  STN_text: 'Tonas',
  GRM_text: 'Gramas',
  KGM_text: 'Kilogramas',
  TNE_text: 'Tona',
  PS_text: 'Svarų už kvadratinį colį',
  MPA_text: 'Megapaskalis',
  C56_text: 'Niutonas kvadratiniam milimetrui',
  C62_text: 'Vienas',
  NL_text: 'Įkelti',
  MT_text: 'Mat',
  P1_text: 'proc',
  CEL_text: 'Celsijaus laipsnis',
  FAH_text: 'Farenheito laipsnis',
  BLL_text: 'Statinė',
  CLT_text: 'Centilitras',
  DLT_text: 'Decilitras',
  GLI_text: 'Imperatoriškasis galonas',
  '2U_text': 'Megagrama',
  SA_text: 'Maišas',
  '60_text': 'Svorio procentas',
  BG_text: 'Krepšys',
  SEC_text: 'Antra',
  MIN_text: 'Minutė',
  '64_text': 'Svaras kvadratiniam coliui – matuoklis',
  SP_text: 'Lentynų paketas',
  MMK_text: 'Kvadratinis milimetras',
  MTN_text: 'Metrinė tona',
  GT_text: 'Gigatonas',
  '/NL_text': 'Už apkrovą',
  '/EA_text': 'Už kiekį',
  '/H/ + h_text': 'Per valandą',
  '/YQ/ + YDQ_text': 'Už kubinį kiemą',
  '/MQ/ + MTQ_text': 'Už kubinį metrą',
  '/MN/ + MIN_text': 'Per minutę',
  '/MT_text': 'Per metrą',
  DSG_text: 'Dozavimas',
  '/C_text': '100 svorio',
  '64_2_text': 'Specifinis',
  MTQ: `{value, plural,
    =0 {0 m\u00B3}
    one {1 m\u00B3}
    other {# m\u00B3}
  }`,
  M3: `{value, plural,
    =0 {0 m\u00B3}
    one {1 m\u00B3}
    other {# m\u00B3}
  }`,
  LTR: `{value, plural,
    =0 {0 Litrų}
    one {1 Litro}
    other {# Litrų}
  }`,
  TO: `{value, plural,
    =0 {0 Tonų}
    one {1 Tonas}
    other {# Tonų}
  }`,
  ITEM: `{value, plural,
    =0 {0 Daiktai}
    one {1 Prekė}
    other {# Daiktai}
  }`,
  YDQ_short: `{value, plural,
    =0 {0 y³}
    one {1 y³}
    other {# y³}
  }`,
  YDQ: `{value, plural,
    =0 {0 Kubiniai kiemai}
    one {1 Kubinis kiemas}
    other {# Kubiniai kiemai}
  }`,
  GLL: `{value, plural,
    =0 {0 Galonai}
    one {1 Galonas}
    other {# Galonai}
  }`,
  EA: `{value, plural,
    =0 {0 Kiekvienas}
    one {1 Kiekvienas}
    other {# Kiekvienas}
  }`,
  MIN: `{value, plural,
    =0 {0 Minutės}
    one {1 Minutė}
    other {# Minutės}
  }`,
  ACR: `{value, plural,
    =0 {0 Akrų}
    one {1 Akras}
    other {# Akrų}
  }`,
  HUR: `{value, plural,
    =0 {0 Valandos}
    one {1 Valanda}
    other {# Valandos}
  }`,
  INH: `{value, plural,
    =0 {0 Coliai}
    one {1 Col}
    other {# Coliai}
  }`,
  FOT: `{value, plural,
    =0 {0 Pėdos}
    one {1 Pėda}
    other {# Pėdos}
  }`,
  YRD: `{value, plural,
    =0 {0 Kiemai}
    one {1 Kiemas}
    other {# Kiemai}
  }`,
  MMT: `{value, plural,
    =0 {0 Milimetrai}
    one {1 Milimetras}
    other {# Milimetrai}
  }`,
  CMT: `{value, plural,
    =0 {0 centimetrai}
    one {1 centimetras}
    other {# centimetrai}
  }`,
  MTR: `{value, plural,
    =0 {0 Metrai}
    one {1 Metras}
    other {# Metrai}
  }`,
  SMI: `{value, plural,
    =0 {0 mylios (įstatymo mylios)}
    one {1 Mylia (statute mylia)}
    other {# mylios (įstatymo mylios)}
  }`,
  KMT: `{value, plural,
    =0 {0 Kilometrai}
    one {1 Kilometras}
    other {# Kilometrai}
  }`,
  INK: `{value, plural,
    =0 {0 Kvadratiniai coliai}
    one {1 Kvadratinis colis}
    other {# Kvadratiniai coliai}
  }`,
  FTK: `{value, plural,
    =0 {0 Kvadratinės pėdos}
    one {1 Kvadratinė pėda}
    other {# Kvadratinės pėdos}
  }`,
  YDK: `{value, plural,
    =0 {0 Kvadratiniai kiemai}
    one {1 Kvadratinis kiemas}
    other {# Kvadratiniai kiemai}
  }`,
  MIK: `{value, plural,
    =0 {0 Kvadratinės mylios}
    one {1 Kvadratinė mylia}
    other {# Kvadratinės mylios}
  }`,
  CMK: `{value, plural,
    =0 {0 Kvadratiniai centimetrai}
    one {1 Kvadratinis centimetras}
    other {# Kvadratiniai centimetrai}
  }`,
  MTK: `{value, plural,
    =0 {0 Kvadratinis metras}
    one {1 Kvadratinis metras}
    other {# Kvadratiniai metrai}
  }`,
  KMK: `{value, plural,
    =0 {0 Kvadratiniai kilometrai}
    one {1 Kvadratinis kilometras}
    other {# Kvadratiniai kilometrai}
  }`,
  INQ: `{value, plural,
    =0 {0 Kubiniai coliai}
    one {1 Kubinis colis}
    other {# Kubiniai coliai}
  }`,
  MMQ: `{value, plural,
    =0 {0 Kubiniai milimetrai}
    one {1 Kubinis milimetras}
    other {# Kubiniai milimetrai}
  }`,
  FTQ: `{value, plural,
    =0 {0 Kubinės pėdos}
    one {1 Kubinė pėda}
    other {# Kubinės pėdos}
  }`,
  CMQ: `{value, plural,
    =0 {0 Kubiniai centimetrai}
    one {1 Kubinis centimetras}
    other {# Kubiniai centimetrai}
  }`,
  OZA: `{value, plural,
    =0 {0 Skysčių uncijų}
    one {1 Skysčio uncija}
    other {# Skysčių uncijų}
  }`,
  PT: `{value, plural,
    =0 {0 Pintos}
    one {1 Pintas}
    other {# Pintos}
  }`,
  QT: `{value, plural,
    =0 {0 Kvartalai}
    one {1 Kvart}
    other {# Kvartalai}
  }`,
  MLT: `{value, plural,
    =0 {0 Mililitrai}
    one {1 Mililitras}
    other {# Mililitrai}
  }`,
  ONZ: `{value, plural,
    =0 {0 Uncijos}
    one {1 Uncija}
    other {# Uncijos}
  }`,
  LBR: `{value, plural,
    =0 {0 Svarų}
    one {1 Svaras}
    other {# Svarų}
  }`,
  STN: `{value, plural,
    =0 {0 Tonų}
    one {1 Tonas}
    other {# Tonų}
  }`,
  GRM: `{value, plural,
    =0 {0 Gramai}
    one {1 Gramas}
    other {# Gramai}
  }`,
  KGM: `{value, plural,
    =0 {0 Kilogramai}
    one {1 Kilogramas}
    other {# Kilogramai}
  }`,
  TNE: `{value, plural,
    =0 {0 Tonų}
    one {1 Tona}
    other {# Tonų}
  }`,
  PS: `{value, plural,
    =0 {0 psi}
    one {1 psi}
    other {# psi}
  }`,
  MPA: `{value, plural,
    =0 {0 Megapaskaliai}
    one {1 Megapaskalis}
    other {# Megapaskaliai}
  }`,
  C56: `{value, plural,
    =0 {0 Niutonai kvadratiniam milimetrui}
    one {1 Niutonas kvadratiniam milimetrui}
    other {# Niutonai kvadratiniam milimetrui}
  }`,
  C62: `{value, plural,
    =0 {0 Vienas}
    one {1 Vienas}
    other {# Vienas}
  }`,
  NL: `{value, plural,
    =0 {0 Kroviniai}
    one {1 Įkelti}
    other {# Kroviniai}
  }`,
  MT: `{value, plural,
    =0 {0 Mats}
    one {1 Mat}
    other {# Mats}
  }`,
  P1: `{value, plural,
    =0 {0 proc}
    one {1 proc}
    other {# proc}
  }`,
  CEL: `{value, plural,
    =0 {0 Celsijaus laipsnių}
    one {1 Celsijaus laipsnis}
    other {# Celsijaus laipsnių}
  }`,
  FAH: `{value, plural,
    =0 {0 Farenheito laipsniai}
    one {1 Farenheito laipsnis}
    other {# Farenheito laipsniai}
  }`,
  BLL: `{value, plural,
    =0 {0 Statinės}
    one {1 Statinė}
    other {# Statinės}
  }`,
  CLT: `{value, plural,
    =0 {0 Centilitrai}
    one {1 Centilitras}
    other {# Centilitrai}
  }`,
  DLT: `{value, plural,
    =0 {0 Decilitrų}
    one {1 Decilitras}
    other {# Decilitrų}
  }`,
  GLI: `{value, plural,
    =0 {0 Galonai}
    one {1 Galonas}
    other {# Galonai}
  }`,
  '2U': `{value, plural,
    =0 {0 Megagramos}
    one {1 Megagrama}
    other {# Megagramos}
  }`,
  SA: `{value, plural,
    =0 {0 Maišai}
    one {1 Maišas}
    other {# Maišai}
  }`,
  60: `{value, plural,
    =0 {0 Svorio procentas}
    one {1 Svorio procentas}
    other {# Svorio procentas}
  }`,
  BG: `{value, plural,
    =0 {0 Krepšiai}
    one {1 Krepšys}
    other {# Krepšiai}
  }`,
  SEC: `{value, plural,
    =0 {0 sekundės}
    one {1 Antra}
    other {# sekundės}
  }`,
  64: `{value, plural,
    =0 {0 Svarai kvadratiniame colyje – matuoklis}
    one {1 Svaras kvadratiniam coliui – matuoklis}
    other {# Svarai kvadratiniame colyje – matuoklis}
  }`,
  SP: `{value, plural,
    =0 {0 Lentynų paketai}
    one {1 Lentynų paketas}
    other {# Lentynų paketai}
  }`,
  MMK: `{value, plural,
    =0 {0 Kvadratiniai milimetrai}
    one {1 Kvadratinis milimetras}
    other {# Kvadratiniai milimetrai}
  }`,
  MTN: `{value, plural,
    =0 {0 Metrinės tonos}
    one {1 Metrinė tona}
    other {# Metrinės tonos}
  }`,
  GT: `{value, plural,
    =0 {0 Gigatonai}
    one {1 Gigatonas}
    other {# Gigatonai}
  }`,
  '/NL': `{value, plural,
    =0 {0 Už apkrovą}
    one {1 Už apkrovą}
    other {# Už apkrovą}
  }`,
  '/EA': `{value, plural,
    =0 {0 Už kiekį}
    one {1 Už kiekį}
    other {# Už kiekį}
  }`,
  '/H/ + h': `{value, plural,
    =0 {0 Per valandą}
    one {1 Per valandą}
    other {# Per valandą}
  }`,
  '/YQ/ + YDQ': `{value, plural,
    =0 {0 Už kubinį kiemą}
    one {1 Už kubinį kiemą}
    other {# Už kubinį kiemą}
  }`,
  '/MQ/ + MTQ': `{value, plural,
    =0 {0 Už kubinį metrą}
    one {1 Už kubinį metrą}
    other {# Už kubinį metrą}
  }`,
  '/MN/ + MIN': `{value, plural,
    =0 {0 Per minutę}
    one {1 Per minutę}
    other {# Per minutę}
  }`,
  '/MT': `{value, plural,
    =0 {0 Per metrą}
    one {1 Per metrą}
    other {# Per metrą}
  }`,
  DSG: `{value, plural,
    =0 {0 Dozavimas}
    one {1 Dozavimas}
    other {# Dozavimas}
  }`,
  '/C': `{value, plural,
    =0 {0 100 svorio}
    one {1 100 svorio}
    other {# 100 svorio}
  }`,
  '64_2': `{value, plural,
    =0 {0 Specifinis}
    one {1 Specifinis}
    other {# Specifinis}
  }`,
  LTR_short: `{value, plural,
  =0 {0 L}
  one {1 L}
  other {# L}
  }`,
  TO_short: `{value, plural,
  =0 {0 tonų}
  one {1 tonų}
  other {# tonų}
}`,
  ITEM_short: `{value, plural,
  =0 {0 Daiktai}
  one {1 Prekė}
  other {# Daiktai}
}`,
  GLL_short: `{value, plural,
  =0 {0 gal}
  one {1 gal}
  other {# gal}
}`,
  EA_short: `{value, plural,
  =0 {0 ea}
  one {1 ea}
  other {# ea}
}`,
  MIN_short: `{value, plural,
  =0 {0 min}
  one {1 min}
  other {# min}
}`,
  ACR_short: `{value, plural,
  =0 {0 ac}
  one {1 ac}
  other {# ac}
}`,
  HUR_short: `{value, plural,
  =0 {0 hr}
  one {1 hr}
  other {# hr}
}`,
  INH_short: `{value, plural,
  =0 {0 in}
  one {1 in}
  other {# in}
}`,
  FOT_short: `{value, plural,
  =0 {0 ft}
  one {1 ft}
  other {# ft}
}`,
  YRD_short: `{value, plural,
  =0 {0 yd}
  one {1 yd}
  other {# yd}
}`,
  MMT_short: `{value, plural,
  =0 {0 mm}
  one {1 mm}
  other {# mm}
}`,
  CMT_short: `{value, plural,
  =0 {0 cm}
  one {1 cm}
  other {# cm }
}`,
  MTR_short: `{value, plural,
  =0 {0 m}
  one {1 m}
  other {# m}
}`,
  SMI_short: `{value, plural,
  =0 {0 mylios (st mi)}
  one {1 mylia ((st mi)}
  other {# mylios ((st mi)}
}`,
  KMT_short: `{value, plural,
  =0 {0 km}
  one {1 km}
  other {# km}
}`,
  INK_short: `{value, plural,
  =0 {0 in²}
  one {1 in²}
  other {# in²}
}`,
  FTK_short: `{value, plural,
  =0 {0 ft²}
  one {1 ft²}
  other {# ft²}
}`,
  YDK_short: `{value, plural,
  =0 {0 yd²}
  one {1 yd²}
  other {# yd²}
}`,
  MIK_short: `{value, plural,
  =0 {0 mi²}
  one {1 mi²}
  other {# mi²}
}`,
  CMK_short: `{value, plural,
  =0 {0 cm²}
  one {1 cm²}
  other {# cm²}
}`,
  MTK_short: `{value, plural,
  =0 {0 m²}
  one {1 m²}
  other {# m²}
}`,
  KMK_short: `{value, plural,
  =0 {0 km²}
  one {1 km²}
  other {# km²}
}`,
  INQ_short: `{value, plural,
  =0 {0 in³}
  one {1 in³}
  other {# in³}
}`,
  MMQ_short: `{value, plural,
  =0 {0 mm³}
  one {1 mm³}
  other {# mm³}
}`,
  FTQ_short: `{value, plural,
  =0 {0 ft³}
  one {1 ft³}
  other {# ft³}
}`,
  CMQ_short: `{value, plural,
  =0 {0 cm³}
  one {1 cm³}
  other {# cm³}
}`,
  OZA_short: `{value, plural,
  =0 {0 fl oz}
  one {1 fl oz}
  other {# fl oz}
}`,
  PT_short: `{value, plural,
  =0 {0 pt}
  one {1 pt}
  other {# pt}
}`,
  QT_short: `{value, plural,
  =0 {0 qt}
  one {1 qt}
  other {# qt}
}`,
  MLT_short: `{value, plural,
  =0 {0 mL}
  one {1 mL}
  other {# mL}
}`,
  ONZ_short: `{value, plural,
  =0 {0 oz}
  one {1 oz}
  other {# oz}
}`,
  LBR_short: `{value, plural,
  =0 {0 lb}
  one {1 lb}
  other {# lb}
}`,
  STN_short: `{value, plural,
  =0 {0 tonų}
  one {1 tonų}
  other {# tonų}
}`,
  GRM_short: `{value, plural,
  =0 {0 g}
  one {1 g}
  other {# g}
}`,
  KGM_short: `{value, plural,
  =0 {0 kg}
  one {1 kg}
  other {# kg}
}`,
  TNE_short: `{value, plural,
  =0 {0 t}
  one {1 t}
  other {# t}
}`,
  PS_short: `{value, plural,
  =0 {0 psi}
  one {1 psi}
  other {# psi}
}`,
  MPA_short: `{value, plural,
  =0 {0 mpa}
  one {1 mpa}
  other {# mpa}
}`,
  C56_short: `{value, plural,
  =0 {0 Niutonai kvadratiniam milimetrui}
  one {1 Niutonas kvadratiniam milimetrui}
  other {# Niutonai kvadratiniam milimetrui}
}`,
  C62_short: `{value, plural,
  =0 {0 Vienas}
  one {1 Vienas}
  other {# Vienas}
}`,
  NL_short: `{value, plural,
  =0 {0 Kroviniai}
  one {1 Įkelti}
  other {# Kroviniai}
}`,
  MT_short: `{value, plural,
  =0 {0 Mats}
  one {1 Mat}
  other {# Mats}
}`,
  P1_short: `{value, plural,
  =0 {0 %}
  one {1 %}
  other {# %}
}`,
  CEL_short: `{value, plural,
  =0 {0 c}
  one {1 c}
  other {# c}
}`,
  FAH_short: `{value, plural,
  =0 {0 f}
  one {1 f}
  other {# f}
}`,
  BLL_short: `{value, plural,
  =0 {0 bbl}
  one {1 bbl}
  other {# bbl}
}`,
  CLT_short: `{value, plural,
  =0 {0 cL}
  one {1 cL}
  other {# cL}
}`,
  DLT_short: `{value, plural,
  =0 {0 dL}
  one {1 dL}
  other {# dL}
}`,
  GLI_short: `{value, plural,
  =0 {0 gal}
  one {1 gal}
  other {# gal}
}`,
  '2U_short': `{value, plural,
  =0 {0 Megagramos}
  one {1 Megagrama}
  other {# Megagramos}
}`,
  SA_short: `{value, plural,
  =0 {0 Maišai}
  one {1 Maišas}
  other {# Maišai}
}`,
  '60_short': `{value, plural,
  =0 {0 % Svoris}
  one {1 % Svoris}
  other {# % Svoris}
}`,
  BG_short: `{value, plural,
  =0 {0 Krepšiai}
  one {1 Krepšys}
  other {# Krepšiai}
}`,
  SEC_short: `{value, plural,
  =0 {0 sek}
  one {1 sek}
  other {# sek}
}`,
  '64_short': `{value, plural,
  =0 {0 Svarai kvadratiniame colyje – matuoklis}
  one {1 Svaras kvadratiniam coliui – matuoklis}
  other {# Svarai kvadratiniame colyje – matuoklis}
}`,
  SP_short: `{value, plural,
  =0 {0 Lentynų paketai}
  one {1 Lentynų paketas}
  other {# Lentynų paketai}
}`,
  MMK_short: `{value, plural,
  =0 {0 Kvadratiniai milimetrai}
  one {1 Kvadratinis milimetras}
  other {# Kvadratiniai milimetrai}
}`,
  MTN_short: `{value, plural,
  =0 {0 mt}
  one {1 mt}
  other {# mt}
}`,
  GT_short: `{value, plural,
  =0 {0 gt}
  one {1 gt}
  other {# gt}
}`,
  '/NL_short': `{value, plural,
  =0 {0 /Load}
  one {1 /Load}
  other {# /Load}
}`,
  '/EA_short': `{value, plural,
  =0 {0 /ea}
  one {1 /ea}
  other {# /ea}
}`,
  '/H/ + h_short': `{value, plural,
  =0 {0 /Hour}
  one {1 /Hour}
  other {# /Hour}
}`,
  '/YQ/ + YDQ_short': `{value, plural,
  =0 {0 /y³}
  one {1 /y³}
  other {# /y³}
}`,
  '/MQ/ + MTQ_short': `{value, plural,
  =0 {0 /m³}
  one {1 /m³}
  other {# /m³}
}`,
  '/MN/ + MIN_short': `{value, plural,
  =0 {0 /min}
  one {1 /min}
  other {# /min}
}`,
  '/MT_short': `{value, plural,
  =0 {0 /m}
  one {1 /m}
  other {# /m}
}`,
  DSG_short: `{value, plural,
  =0 {0 Dozavimas}
  one {1 Dozavimas}
  other {# Dozavimas}
}`,
  '/C_short': `{value, plural,
  =0 {0 /c}
  one {1 /c}
  other {# /c}
}`,
  '64_2_short': `{value, plural,
  =0 {0 Specifinis}
  one {1 Specifinis}
  other {# Specifinis}
}`,
  mixIdLabel: 'Mišinio ID / aprašymas',
  productIdLabel: 'Produkto ID / aprašymas',
  orderedQtyLabel: 'Užsakytas kiekis',
  loadedQtyLabel: 'Pakrautas Kiekis',
  addedByCustomer: 'Pridėjo Klientas',
  PRINTED: 'Bilietas',
  LOADING_STARTED: 'Pradėti įkėlimą',
  LOADING_COMPLETE: 'Baigti įkėlimą',
  TO_JOB: 'Kairysis augalas',
  ARRIVE_JOB: 'Atvykimo svetainė',
  UNLOADING: 'Pradėti iškrovimą',
  END_UNLOADING: 'Baigti iškrovimą',
  LEAVE_JOB: 'Palikite darbą',
  IN_YARD: 'Kieme',
  WASHING: 'Skalbimas',
  END_WASHING: 'Skalbimo pabaiga',
  PUMPING_STARTED: 'Paleiskite siurblį',
  PUMPING_COMPLETE: 'Baigti siurblį',
  READY_TO_PUMP: 'Paruošta siurbti',
  FIRST_WCCONTACT: 'Pirmasis vandens cemento kontaktas',
  plantName: 'Augalo pavadinimas',
  plantAddress: 'Augalų adresas',
  loadingScheduleStart: 'Suplanuotas įkėlimo laikas',
  deliveryAddress: 'Pristatymo adresas',
  phoneNumber: 'Telefono numeris',
  unloadingScheduleStart: 'Planuojamas iškrovimo laikas (NAL)',
  agreedUnloading: 'Užsakytas iškrovimo laikas',
  deliveryInformation: 'Pristatymo informacija',
  next: 'Kitas',
  material: 'Medžiaga',
  loadingPoint: 'Pakrovimo vieta',
  unloadingPoint: 'Iškrovimo vieta',
  getDirections: 'Gaukite nuorodas',
  comment: 'komentuoti',
  sapDeliveryNumber: 'SAP pristatymo numeris (BCC numeris)',
  salesOrderNumber: 'Pardavimo užsakymo numeris ir prekės eilutė',
  wcDateTime: 'Data ir laikas W/C kontaktas',
  po: 'PO numeris',
  orderedByName: 'Užsakymas pateiktas vardu',
  orderedByPhone: 'Užsakymas pateiktas telefono numeriu',
  resourceId: 'Ištekliaus ID',
  totalLoadedQty: 'Visas pakrautas kiekis, įskaitant šią apkrovą',
  spacing: 'Pakrovimo vieta',
  deliveryFlow: 'Pristatymo srautas',
  timeOnSite: 'Bendras laikas vietoje / užsakytas iškrovimo laikas',
  salesText: 'Pardavimo tekstas (medžiagos ID)',
  strengthClass: 'Jėgos klasė',
  environmentExposure: 'Aplinkos poveikis',
  metExposureClasses: 'Atitinka ekspozicijos klases',
  dmax: 'Dmaks',
  standardCert: 'Standartinis (sertifikavimas)',
  workabilityTarget: 'Kliento darbingumo tikslas',
  stoneQuality: 'Akmens kokybė',
  sandQuality: 'Smėlio kokybė',
  targetWC: 'Tikslinis W/C santykis pagal receptą',
  controlClass: 'Kontrolės klasė',
  chlorideClass: 'Chlorido klasė',
  typeAndStrength1: 'Cemento tipas ir 1 stiprumo klasė',
  typeAndStrength2: 'Cemento tipas ir 2 stiprumo klasė',
  typeOfAddition: 'Papildymo tipas',
  typeOfAdmixture: 'Priedo tipas',
  orderedTemp: 'Užsakyta temperatūra',
  fibers1: 'Pluošto tipas ir kiekis 1',
  fibers2: 'Pluoštų tipas ir kiekis 2',
  calculatedMaturityTime: 'Apskaičiuotas brandinimo laikas nuo W/C kontaktinio laiko',
  mixIdentity: 'Sumaišykite tapatybę',
  grade: 'Įvertinimas',
  mixType: 'Mišinio tipas',
  maxAggSize: 'Maksimalus Agg dydis',
  maxAggType: 'Max Agg tipas',
  cementType: 'Cemento tipas',
  admixtures: 'Priemaišos',
  addmixDescription: 'Admix aprašymas',
  slump: 'Nuosmukis',
  minCementContent: 'Minimalus cemento kiekis',
  maxWatCemRatio: 'Maksimalus vandens/cemento santykis',
  maxWaterToAdd: 'Maksimalus vandens kiekis',
  mortarMinWorkingLife: 'Minkštas skiedinio darbo laikas',
  code: 'Kodas',
  dcClass: 'dcClass',
  chloride: 'Chloridas',
  signedByHanson: 'Pasirašė Hansonas',
  warmStamp: 'Šiltas antspaudas',
  coldStamp: 'Šaltas antspaudas',
  containsSikatard: 'Sudėtyje yra Sikatard',
  containsDelvo: 'Sudėtyje yra Delvo',
  generalDelivery: 'Bendroji pristatymo informacija',
  materialInfo: 'Informacija apie medžiagą',
  water: 'Vanduo',
  materialService: 'Medžiaga / Paslauga',
  returnedMaterial: 'Grąžinta medžiaga',
  returnedConcrete: 'Grąžintas betonas',
  waterAdded: 'Pridėta vandens',
  concreteOnTruck: 'Betonas ant sunkvežimio',
  concreteOnTruckUom: 'Numatytasis betonas ant sunkvežimio UOM',
  reason: 'Priežastis',
  customerAddedWater: 'Klientas pridėjo vandens',
  addWater: 'Įpilkite Vandens',
  addedAt: 'Pridėta adresu',
  addMaterialService: 'Pridėti medžiagą / paslaugą',
  customerAddedProduct: 'Klientas pridėjo produktą',
  addReturnedMaterial: 'Pridėti grąžintą medžiagą',
  leftover: 'Likę',
  submitAcceptance: 'Pateikti sutikimą',
  accepted: 'Priimta',
  rejected: 'Atmesta',
  customerAcceptance: 'Priėmimas',
  finalize: 'Užbaigti',
  earlyAcceptance: 'Ankstyvas priėmimas',
  materialSummary: 'Medžiagos santrauka',
  mix: 'Sumaišykite',
  ordered: 'Užsakyta',
  loaded: 'Pristatymo apkrova',
  totalOrdered: 'Bendras užsakymo kiekis',
  loadedOrderQuantity: 'Pakrautas užsakymo kiekis',
  loadedOrder: 'Įkeltas užsakymas',
  driverComment: 'Vairuotojo komentaras',
  driverCommentInternal: 'Vairuotojo komentaras (vidinis)',
  customerComment: 'Kliento komentaras',
  editComment: 'Redaguoti komentarą',
  addComment: 'Pridėti komentarą',
  additionalInfo: 'Papildoma informacija',
  onBoard: 'Laive',
  driver: 'Vairuotojas',
  commentInstruction: 'Komentarų instrukcija',
  signatureInstruction: 'Kliento parašas*',
  customerSignature: 'Kliento parašas',
  general: 'Generolas',
  status: 'Būsena',
  updateStatusTime: 'Atnaujinti būsenos laiką',
  delete: 'Ištrinti',
  cancel: 'Atšaukti',
  back: 'Atgal',
  add: 'Pridėti',
  edit: 'Redaguoti',
  done: 'Atlikta',
  ok: 'Gerai',
  decline: 'Atmesti',
  Submit: 'Pateikti',
  submit: 'Pateikti',
  lastRefresh: 'Paskutinis atnaujinimas',
  refreshEnabled: 'Įgalinti Refresh',
  id: 'ID',
  name: 'Vardas',
  invoiceable: 'Išrašoma sąskaita faktūra',
  provideSignature: 'Pateikite parašą',
  ticket: 'Bilietas',
  details: 'Detalės',
  qrCode: 'QR kodas',
  driverAcceptanceReason: 'Priežastis',
  driverAcceptance: 'Vairuotojo priėmimas',
  'payment-method': 'Mokėjimo būdai',
  'add-payment-method': 'Pridėti mokėjimo būdą',
  'reason-code': 'Priežasties kodas',
  'add-reason-code': 'Pridėti priežasties kodą',
  'qr-code': 'QR kodas',
  'unloading-method': 'Iškrovimo būdai',
  'add-unloading-method': 'Pridėti iškrovimo metodą',
  'driver-comment': 'Vairuotojo komentarai',
  'add-driver-comment': 'Pridėti vairuotojo komentarą',
  'driver-sellable': 'Parduodamas vairuotojas',
  vehicle: 'Transporto priemonės',
  'add-vehicle': 'Pridėti transporto priemonę',
  'vehicle-type': 'Transporto priemonių tipai',
  vehicleTypes: 'Transporto priemonių tipai',
  vehicleType: 'Transporto priemonės tipas',
  'add-vehicle-type': 'Pridėti transporto priemonės tipą',
  countries: 'Šalys',
  country: 'Šalis',
  type: 'Tipas',
  uom: 'UOM',
  mandatory: 'Privaloma',
  qrTemplate: 'QR kodo šablonas',
  includeMixInfo: 'Į QR kodą įtraukite mišinio informaciją',
  includeTicketEvents: 'Įtraukite bilietų įvykius į QR kodą',
  quantityField: 'Įgalinti kiekio lauką',
  concreteOnTruckField: 'Įgalinti betonavimą sunkvežimio lauke',
  materialOnTruckField: 'Įgalinti medžiagą sunkvežimio lauke',
  timeField: 'Įgalinti laiko lauką',
  reasonField: 'Įgalinti priežasties lauką',
  driverInstructions: 'Vairuotojo instrukcijos',
  waitingForTicket: 'Laukiam bilieto...',
  createTestTicketForTruck: 'Sukurkite sunkvežimio bandomąjį bilietą',
  exceedsLoadedQuantity: `Vertė negali viršyti įkelto kiekio {loadedQuantity}.`,
  maxQuantity: 'Didžiausias kiekis',
  maxQuantityError: `Kiekis negali viršyti nustatyto didžiausio kiekio {maxQty}`,
  maxValueError: `Reikšmė negali viršyti nustatyto didžiausio {maxQty}`,
  minValueError: `Reikšmė negali būti mažesnė už apibrėžtą minimalią {minQty}`,
  notAuthorized: 'Neįgaliotas',
  enterTruckNumber: 'Įveskite sunkvežimio numerį',
  setTruckNumber: 'Nustatykite sunkvežimio numerį',
  commentList: 'Komentarų sąrašas',
  list: 'Sąrašas',
  gridPreferences: 'Tinklelio nuostatos',
  loadingUnloadingPoints: 'Pakrovimo/iškrovimo taškai',
  activity: 'Veikla',
  crn: 'Crn',
  update: 'Atnaujinti',
  CONCRETE: 'Betono',
  WATER: 'Vanduo',
  ADDITIVE: 'Priedas',
  'submit-signature-button': 'Priimti',
  'cancel-signature-button': 'Atšaukti',
  uomCode: 'Numatytasis UOM',
  'product-type': 'Produktų tipai',
  'add-product-type': 'Pridėti produkto tipą',
  'add-product': 'Pridėti produktą',
  'setup_driver-comment': 'Vairuotojo komentarai',
  setup_product: 'Produktai',
  'setup_product-type': 'Produktų tipai',
  'setup_qr-code': 'QR kodas',
  'setup_reason-code': 'Priežasties kodai',
  'setup_unloading-method': 'Iškrovimo būdai',
  'setup_entity-mt': 'Įmonė',
  setup_vehicle: 'Transporto priemonės',
  'setup_vehicle-type': 'Transporto priemonių tipai',
  'setup_data-retentions': 'Duomenų saugojimas',
  'add-data-retentions': 'Pridėti duomenų saugojimą',
  'data-retentions': 'Duomenų saugojimas',
  setup_carriers: 'Vežėjai',
  'add-carriers': 'Pridėti vežėjus',
  carriers: 'Vežėjai',
  'setup_concrete-classes': 'Medžiagos atitiktis',
  'add-concrete-classes': 'Pridėti medžiagos atitiktį',
  'concrete-classes': 'Medžiagos atitiktis',
  'setup_forms-and-waivers': 'Formos ir atsisakymai',
  'add-forms-and-waivers': 'Pridėti formas ir atsisakymus',
  'forms-and-waivers': 'Formos ir atsisakymai',
  companyFleet: 'Įmonės laivynas',
  category: 'Kategorija',
  interval: 'Intervalas',
  orders: 'Užsakymai ir bilietai',
  '30days': '30 dienų',
  '60days': '60 dienų',
  '90days': '90 dienų',
  '1year': '1 metai',
  '3years': '3 metai',
  waterMandatory: 'Vanduo Privalomas',
  qrCodeTemplate: 'QR kodo šablonas',
  waterConfig: 'Neprivalomi laukai',
  waterProduct: 'Vanduo',
  waterProductType: 'Vandens produkto tipas',
  defaultWaterProduct: 'Numatytasis vandens produktas',
  invalidTemplate: 'Netinkamas šablonas',
  siteAddress: 'Svetainės adresas',
  siteContactName: 'Svetainės kontaktinis vardas',
  siteContactPhoneNumber: 'Svetainės kontaktinis telefono numeris',
  'clear-signature-button': 'Aiškus parašas',
  customerCommentEnabled: 'Įgalinti kliento komentarą',
  driverCommentEnabled: 'Įgalinti vairuotojo komentarą',
  driverCommentMaxCharacters: 'Maksimalus ilgis',
  customerCommentMaxCharacters: 'Maksimalus ilgis',
  timeZone: 'Laiko juosta',
  driverDidNotAdd: 'Vairuotojas nepridėtas',
  noWaterAdded: 'Vandens nepridėta',
  maxLineItems: 'Maksimalus eilutinių elementų skaičius',
  oneLineItem: 'Turi būti bent 1 eilutės elementas',
  signatureSiteContact: 'Kliento vardas',
  signatureSiteContactMandatory: 'Kliento vardas*',
  ticketEvents: 'Bilietų renginiai',
  hideEvent: 'Slėpti įvykį',
  editable: 'Redaguotina',
  ticketDetail: `Bilietas #{value}`,
  statusTimes: 'Būsenos laikai',
  materialAndDeliveryInfo: 'Informacija apie medžiagą ir pristatymą',
  customerRejection: 'Kliento atmetimas',
  'submit-rejection-button': 'Pateikti atmetimą',
  accept: 'Priimti',
  reject: 'Atmesti apkrovą',
  signature: 'Parašas',
  'no-signature': 'Nėra parašo',
  unFinalizePassword: 'Atšaukti slaptažodžio užbaigimą',
  waterInWorkflow: 'Įgalinkite vandens žingsnį darbo eigoje',
  multicountry: 'Daugiašalis',
  timestampAfterSequence: 'ĮSPĖJIMAS: laikas neturėtų būti prieš ankstesnę laiko žymą',
  timestampBeforeSequence: 'ĮSPĖJIMAS: laikas neturėtų būti po kitos laiko žymos',
  noRestQuantity: 'Nėra grąžinamos medžiagos',
  returnedMaterialMandatory: 'Turi sąveikauti su grąžinama medžiaga',
  driverCommentMaxChars: `Ilgis negali viršyti maks. {maxLength} simbolių.`,
  QrCodeEnabled: 'Įgalinti QR kodą',
  QrMethod_linkBased: 'Nuorodų pagrindu',
  QrMethod_contentBased: 'Pagrįstas turiniu, PASTABA: turiniu pagrįsti QR kodai turi simbolių apribojimus, dėl kurių gali kilti problemų, viršijančių 1024 simbolius.',
  QrMethod_contentBasedWarning: `PASTABA: šį QR kodą sudaro {amount} simboliai, kurių kai kurie telefonai gali neįskaityti.`,
  returnedMaterialInWorkflow: 'Įgalinkite grąžinamos medžiagos veiksmą darbo eigoje',
  materialServiceInWorkflow: 'Įgalinkite medžiagos / paslaugos veiksmą darbo eigoje',
  totalPumpedQuantity: 'Bendras siurbiamas kiekis',
  concrete: 'Betono',
  materialComplianceEnabled: 'Įgalinti medžiagų atitiktį',
  pumpStatusTimes: 'Siurblio būsenos laikai',
  pollingInterval: 'Apklausos intervalas (sekundėmis)',
  tenSecs: 'Intervalas turi būti bent 10 sekundžių',
  materialCompliance: 'Medžiagos atitiktis',
  materialCompliance_notFound: 'Medžiagos atitiktis nerasta',
  materialCompliance_outOfRange_warning: 'Įvesta vertė yra už betono klasės leistinos ribos.',
  consistenceValue: 'Konsistencija – nuosmukis',
  consistenceIsCompliant: 'Konsistencija atitinka BS8500-2',
  airContentValue: 'Oro turinys',
  airContentIsCompliant: 'Oro turinys atitinka BS8500-2',
  consistenceIsCompliantShort: 'Nuoseklumas atitinka',
  airContentIsCompliantShort: 'Oro turinys atitinka',
  compliance: 'Medžiagos atitiktis BS8500-2',
  termsAndConditionsEnabled: 'Įgalinti taisyklių ir sąlygų formą',
  damageWaiverEnabled: 'Įgalinti Atsisakymo nuo žalos formą',
  damageWaiver: 'Atsisakymas nuo žalos',
  damageWaiverAcknowledged: 'Žalos atsisakymas pripažintas',
  dynamicWaiver: 'Dinaminis atsisakymas',
  dynamicWaiverEnabled: 'Įgalinti dinaminio atsisakymo formą',
  ticketListEnabled: 'Įgalinti bilietų sąrašą',
  clearTicketAfterSubmission: 'Išvalykite bilietą po pateikimo',
  keepTicketOpenAfterSubmission: 'Pateikę bilietą palikite atvirą',
  displayTicketList: 'Rodyti bilietų sąrašą',
  supportedLanguages: 'Palaikomos kalbos',
  allow: 'Leisti',
  default: 'Numatytoji',
  isCertificationLossTriggerForReason: 'Pastaba apie sertifikavimo praradimo priežastį',
  isCertificationLossTriggerForProduct: 'Sertifikavimo praradimo pastaba Produktas',
  translations: 'Vertimai',
  family_name: 'Pavardė',
  given_name: 'Vardas',
  email: 'El. paštas',
  role: 'Vaidmuo',
  inviteUser: 'Pakviesti vartotoją',
  carrier: 'Vežėjas',
  emailOrPhoneNumber: 'El. paštas',
  usersEditor: 'Vartotojo redaktorius',
  verifyPassword: 'Patvirtinkite slaptažodį',
  verificationCode: 'Patvirtinimo kodas',
  register: 'Registruotis',
  registerInstructions: 'Norėdami užbaigti registraciją, užpildykite šią formą.',
  'password-requirements': 'Jūsų slaptažodį turi sudaryti bent 8 simboliai, bent 1 didžioji, 1 mažoji raidė, 1 skaičius ir 1 specialusis simbolis.',
  passwordMinCharacters: 'Slaptažodyje turi būti 8 ar daugiau simbolių.',
  passwordMaxCharacters: 'Slaptažodyje negali būti daugiau nei 99 simboliai.',
  passwordLowerCase: 'Slaptažodyje turi būti 1 ar daugiau mažųjų raidžių.',
  passwordUpperCase: 'Slaptažodyje turi būti 1 ar daugiau didžiųjų raidžių.',
  passwordNumber: 'Slaptažodyje turi būti 1 ar daugiau skaitmenų.',
  passwordSpecialCharacter: 'Slaptažodyje turi būti 1 ar daugiau specialiųjų simbolių.',
  passwordsDontMatch: 'Slaptažodžiai nesutampa!',
  success: 'Sėkmės!',
  'registration-success': 'Jūsų registracija buvo sėkminga.',
  'post-registration-instructions': 'Jūs baigėte registracijos procesą. Dabar galite prisijungti.',
  createDate: 'Sukurti datą',
  customerPo: 'Kliento PO numeris',
  specification: 'Specifikacija',
  description: 'Aprašymas',
  classType: 'Klasės tipas',
  minimumValue: 'Minimali vertė',
  maximumValue: 'Didžiausia vertė',
  TrackIt: 'TrackIt',
  trackIt3PContext: '„TrackIt 3P“ kontekstas',
  inviteLanguage: 'Kvietimo kalba',
  truckNumber: 'Sunkvežimio numeris',
  adverseTemperature: 'Aplinkos temperatūra maišymo metu buvo tokia, kad negalime garantuoti, kad betonas bus 5-35oC temperatūros intervale, kaip nurodyta EN 206.',
  environmentalNote: 'Šioje apkrovoje yra aplinkos agento, kuris neviršija 0,03 % betono masės. Vanduo, kuriame yra šios medžiagos, skirtas betono gamybai, atitiks BS EN 1008.',
  unloadingMethodEnabled: 'Įgalinti iškrovimo metodą',
  warrantyVoided: 'Medžiagos garantija negalioja',
  materialWarrantyVoidedEnabled: 'Kai naudojamas sertifikavimo praradimo pranešimas, produktas arba produkto ir priežasties kodas, pasirašydami parodykite sertifikavimo praradimo pažymą.',
  'setup_templates-mt': 'Šablonai',
  copyFrom: 'Kopijuoti iš...',
  copy: 'kopija',
  users: 'Vartotojai',
  setup: 'Sąranka',
  driverExperience: 'Vairuotojo patirtis',
  ticketList: 'Bilietų sąrašas',
  content: 'Turinys',
  WARNINGS: 'Įspėjimai',
  TERMS: 'Sąlygos',
  DAMAGE: 'Žala',
  ADDITIONALWAIVER: 'Papildomas atsisakymas',
  DYNAMICWAIVER: 'Dinaminis atsisakymas',
  source: 'Šaltinis',
  sensorUnable: 'Jutiklis negali nustatyti likusio kiekio.',
  PROBE: 'Zondas',
  DRIVER: 'Vairuotojas',
  DRS: 'DRS',
  waterReleaseFormEnabled: 'Įgalinti vandens išleidimo formą',
  waterRelease: 'Vandens išleidimas',
  waterReleaseMandatory: 'Vandens išleidimas *',
  waterReleaseAcknowledged: 'Vandens išleidimas patvirtintas',
  'assessment-risk': 'Rizikos vertinimas',
  'setup_assessment-risk': 'Rizikos vertinimas',
  'add-assessment-risk': 'Pridėkite rizikos vertinimą',
  enterRecipientsButton: 'Įveskite gavėją (-us)',
  recipientsInstructions: 'Įveskite el. pašto adresą, atskirtą kableliu',
  enter: 'Įeikite',
  invalidEmailAddress: 'neteisingas el. pašto adresas',
  personalDataPolicy: 'Įvesdami asmeninius duomenis į šią formą, patvirtinate, kad turite reikiamus leidimus dalytis tais asmens duomenimis',
  subcategory: 'Subkategorija',
  isRequired: 'Reikalingas',
  riskAssessmentEnabled: 'Įjungti rizikos vertinimą',
  riskAssessment: 'Rizikos vertinimas',
  yes: 'Taip',
  no: 'Nr',
  sourceOptionsSensors: 'Šaltinio parinktys (jutikliai)',
  sourceDcm: 'DCM',
  sourceProbe: 'Zondas',
  availableCustomValues: 'Galimos tinkintos reikšmės',
  ERR_CODE__DUPLICATE: 'Pasikartoti',
  ERR_CODE__DEFAULT_VALUE: 'Jau yra numatytoji reikšmė',
  ERR_CODE__EXISTING_FORM: 'Jau yra aktyvi šios transporto priemonės ir tipo forma',
  availableValues: 'Galimos vertės',
  pump: 'Siurblys',
  DanskName: 'Dansko vardas',
  GermanName: 'Vokiškas pavadinimas',
  EnglishName: 'Angliškas pavadinimas',
  BritainName: 'Britanijos pavadinimas',
  SpanishName: 'Ispaniškas vardas',
  FrenchName: 'Prancūziškas vardas',
  NederlandsName: 'Nyderlandų vardas',
  NorskName: 'Norsk vardas',
  SvenskaName: 'Svenska vardas',
  ItalianName: 'Itališkas vardas',
  PolishName: 'Lenkiškas pavadinimas',
  DanskNameDefault: 'Dansk pavadinimas (numatytasis)',
  GermanNameDefault: 'Vokiškas pavadinimas (numatytasis)',
  EnglishNameDefault: 'Angliškas pavadinimas (numatytasis)',
  BritainNameDefault: 'Didžiosios Britanijos pavadinimas (numatytasis)',
  SpanishNameDefault: 'Ispaniškas pavadinimas (numatytasis)',
  FrenchNameDefault: 'Prancūziškas pavadinimas (numatytasis)',
  NederlandsNameDefault: 'Nyderlandų vardas (numatytasis)',
  NorskNameDefault: 'Norsk vardas (numatytasis)',
  SvenskaNameDefault: 'Svenska vardas (numatytasis)',
  ItalianNameDefault: 'Itališkas pavadinimas (numatytasis)',
  PolishNameDefault: 'Lenkiškas pavadinimas (numatytasis)',
  DanskDescription: 'Dansk Aprašymas',
  GermanDescription: 'Vokiškas aprašymas',
  EnglishDescription: 'Angliškas aprašymas',
  BritainDescription: 'Britanija Aprašymas',
  SpanishDescription: 'Ispanų kalbos aprašymas',
  FrenchDescription: 'Prancūziškas aprašymas',
  NederlandsDescription: 'Nederlands Aprašymas',
  NorskDescription: 'Norsk Aprašymas',
  SvenskaDescription: 'Svenska Aprašymas',
  ItalianDescription: 'Itališkas aprašymas',
  PolishDescription: 'Lenkiškas Aprašymas',
  DanskDescriptionDefault: 'Dansk aprašymas (numatytasis)',
  GermanDescriptionDefault: 'Vokiškas aprašymas (numatytasis)',
  EnglishDescriptionDefault: 'Angliškas aprašymas (numatytasis)',
  BritainDescriptionDefault: 'Britanijos aprašymas (numatytasis)',
  SpanishDescriptionDefault: 'Aprašymas ispanų kalba (numatytasis)',
  FrenchDescriptionDefault: 'Prancūziškas aprašymas (numatytasis)',
  NederlandsDescriptionDefault: 'Nederlands aprašymas (numatytasis)',
  NorskDescriptionDefault: 'Norsk aprašymas (numatytasis)',
  SvenskaDescriptionDefault: 'Svenska aprašymas (numatytasis)',
  ItalianDescriptionDefault: 'Itališkas aprašymas (numatytasis)',
  PolishDescriptionDefault: 'Lenkiškas aprašymas (numatytasis)',
  DanskContent: 'Dansk turinys',
  GermanContent: 'Vokiškas turinys',
  EnglishContent: 'Angliškas turinys',
  BritainContent: 'Britanijos turinys',
  SpanishContent: 'Ispaniškas turinys',
  FrenchContent: 'Prancūziškas turinys',
  NederlandsContent: 'Nederlands turinys',
  NorskContent: 'Norsk turinys',
  SvenskaContent: 'Svenska turinys',
  ItalianContent: 'Itališkas turinys',
  PolishContent: 'lenkiškas turinys',
  DanskContentDefault: '„Dansk“ turinys (numatytasis)',
  GermanContentDefault: 'Vokiškas turinys (numatytasis)',
  EnglishContentDefault: 'Angliškas turinys (numatytasis)',
  BritainContentDefault: 'Britanijos turinys (numatytasis)',
  SpanishContentDefault: 'Ispaniškas turinys (numatytasis)',
  FrenchContentDefault: 'Prancūziškas turinys (numatytasis)',
  NederlandsContentDefault: 'Nederlands turinys (numatytasis)',
  NorskContentDefault: 'Norsk turinys (numatytasis)',
  SvenskaContentDefault: '„Svenska“ turinys (numatytasis)',
  ItalianContentDefault: 'Itališkas turinys (numatytasis)',
  PolishContentDefault: 'Lenkiškas turinys (numatytasis)',
  DanskCategory: 'Dansko kategorija',
  GermanCategory: 'Vokiečių kategorija',
  EnglishCategory: 'Anglų kalbos kategorija',
  BritainCategory: 'Britanijos kategorija',
  SpanishCategory: 'Ispanijos kategorija',
  FrenchCategory: 'Prancūzų kategorija',
  NederlandsCategory: 'Nederlands kategorija',
  NorskCategory: 'Norsk kategorija',
  SvenskaCategory: 'Svenska kategorija',
  ItalianCategory: 'Italų kategorija',
  PolishCategory: 'lenkų kategorija',
  DanskCategoryDefault: 'Dansko kategorija (numatytasis)',
  GermanCategoryDefault: 'Vokiečių kategorija (numatytasis)',
  EnglishCategoryDefault: 'Anglų kalba (numatytasis)',
  BritainCategoryDefault: 'Britanijos kategorija (numatytasis)',
  SpanishCategoryDefault: 'Ispanų kategorija (numatytoji)',
  FrenchCategoryDefault: 'Prancūzų kategorija (numatytoji)',
  NederlandsCategoryDefault: 'Nederlands kategorija (numatytasis)',
  NorskCategoryDefault: 'Norsk kategorija (numatytasis)',
  SvenskaCategoryDefault: 'Svenska kategorija (numatytasis)',
  ItalianCategoryDefault: 'Italų kategorija (numatytasis)',
  PolishCategoryDefault: 'Lenkų kategorija (numatytasis)',
  DanskSubcategory: 'Dansko subkategorija',
  GermanSubcategory: 'Vokiečių subkategorija',
  EnglishSubcategory: 'Anglų kalbos subkategorija',
  BritainSubcategory: 'Britanijos subkategorija',
  SpanishSubcategory: 'Ispanijos subkategorija',
  FrenchSubcategory: 'Prancūzų subkategorija',
  NederlandsSubcategory: 'Nederlands subkategorija',
  NorskSubcategory: 'Norsk subkategorija',
  SvenskaSubcategory: 'Svenska subkategorija',
  ItalianSubcategory: 'Italų subkategorija',
  PolishSubcategory: 'Lenkijos subkategorija',
  DanskSubcategoryDefault: 'Dansk subkategorija (numatytoji)',
  GermanSubcategoryDefault: 'Vokiečių subkategorija (numatytoji)',
  EnglishSubcategoryDefault: 'Anglų kalbos subkategorija (numatytoji)',
  BritainSubcategoryDefault: 'Britanijos subkategorija (numatytoji)',
  SpanishSubcategoryDefault: 'Ispanų kalbos subkategorija (numatytoji)',
  FrenchSubcategoryDefault: 'Prancūzų subkategorija (numatytoji)',
  NederlandsSubcategoryDefault: 'Nederlands subkategorija (numatytasis)',
  NorskSubcategoryDefault: 'Norsk subkategorija (numatytoji)',
  SvenskaSubcategoryDefault: 'Svenska subkategorija (numatytasis)',
  ItalianSubcategoryDefault: 'Italų subkategorija (numatytoji)',
  PolishSubcategoryDefault: 'Lenkų subkategorija (numatytoji)',
  priorSignatures: 'Ankstesni parašai',
  damageWaiverSignature: 'Žalos atsisakymo parašas',
  waterReleaseSignature: 'Vandens išleidimo parašas',
  errors,
  themes,
  isPDFRecipientListEnable: 'Įgalinti PDF gavėjų sąrašą kliento parašo ekrane',
  isRejectLoadsEnable: 'Įgalinti Atmesti apkrovas po atvykimo į svetainę',
  rejectLoad_returnedMaterial: 'Grąžintos medžiagos darbo eigos mygtukas',
  rejectLoad_returnedAndFinalize: 'Grąžinta medžiaga ir darbo eigos užbaigimo mygtukai',
  driverRejection: 'Atmesti apkrovą',
  submitRejection: 'Pateikti Atmesti',
  costAndPaymentsSummary: 'Išlaidų ir mokėjimų suvestinė',
  groupCostPriorTotal: 'Užsisakykite siuntimo kainą iki viso',
  subtotal: 'Tarpinė suma',
  tax: 'Mokesčiai',
  remainingBalance: 'Likęs balansas',
  paymentAmount: 'Mokėjimo suma',
  total: 'Iš viso',
  paymentMethod: 'Mokėjimo būdas',
  paymentProducts: 'Produktai',
  unitPrice: 'Vieneto kaina',
  amount: 'Suma',
  otherPaymentMethod: 'Kitas mokėjimo būdas',
  method: 'Metodas',
  paymentOptions: 'Mokėjimo parinktys',
  typeAdditionalInfo: 'Čia įveskite papildomą informaciją',
  COD: 'Grynieji pinigai pristatymo metu',
  AMEX: 'American Express',
  CASH: 'Grynieji pinigai',
  CHECK: 'Patikrinkite',
  'CREDIT CARD': 'Kreditinė kortelė',
  ACCOUNT: 'Atidaryti sąskaitą',
  UNKNOWN: 'Nežinoma',
  remainingMaterial: 'Likusi medžiaga',
  splitLoad: 'Padalintas krovinys – keli',
  isEnablePaymentAndCostWorkflows: 'Įgalinkite mokėjimo ir išlaidų darbo eigą',
  dotWorkflow: 'Partijos informacija',
  inspectorSignature: 'Inspektoriaus parašas',
  producerSignature: 'Gamintojo parašas',
  addedItems: 'Pridėti elementai',
  producerSignatureContact: 'Gamintojo pavadinimas',
  inspectorSignatureContact: 'Inspektoriaus vardas',
  airTempValue: 'Oro Temperatūra',
  concreteTempValue: 'Betono temperatūra',
  cylinderNumber: 'Cilindro numeris',
  materialOnTruck: 'Medžiaga ant sunkvežimio',
  waterLocation: 'Vandens vieta',
  waterAtPlant: 'Vanduo augale (gl)',
  waterAtJobsite: 'Vanduo darbo vietoje (gl)',
  totalActualWater: 'Bendras faktinis vanduo',
  timeDischarged: 'Iškrovimo laikas',
  ingredient: 'Ingredientas',
  mcFac: 'MCFac',
  absFac: 'ABSFAC',
  od: 'OD',
  abs: 'ABS',
  ssd: 'SSD',
  freeMst: 'Nemokamas Mst',
  cydsTarg: 'CYDS TARG',
  target: 'Tikslas',
  actual: 'Faktinis',
  freWat: 'Nemokamas vanduo',
  trim: 'Apkarpyti',
  batchInformation: 'Partijos informacija',
  numberOfBatches: 'Partijų skaičius',
  totalWater: 'Bendras vanduo',
  designWater: 'Dizaino vanduo',
  toAdd: 'Norėdami pridėti',
  designWC: 'Dizainas W/C',
  waterCement: 'Vanduo / Cementas',
  waterInTruck: 'Vanduo sunkvežimyje',
  adjustWater: 'Sureguliuokite vandenį',
  trimWater: 'Apipjaustykite vandenį',
  plantWeather: 'Augalų orai',
  rh: 'RH',
  observationTime: 'Stebėjimo laikas',
  address: 'Adresas',
  plant: 'Augalas',
  sp: 'S.P. #',
  beginTime: 'Pradžios laikas',
  mixDesc: 'Mišinio aprašymas',
  qtyOder: 'KV užsakymas',
  poTag: 'PO #',
  bridge: 'Tiltas #',
  volume: 'Apimtis',
  truckTag: 'Sunkvežimio #',
  qtyDelivered: 'Kiekis pristatytas',
  qtyOrder: 'KV užsakymas',
  job: 'Darbas #',
  batchRecord: 'Partijos įrašas',
  mixID: 'Mišinio ID',
  loads: 'Kroviniai',
  isDot: 'Ar DOT',
  onlyPrimaryLineItem: 'Tik pirminis eilutės elementas',
  tolStatus: 'TOL būsena',
  lastUpdate: 'Paskutinis atnaujinimas',
  driverClickedFinalize: 'Vairuotojas spustelėjo Užbaigti',
  autoSubmit: 'Automatinis pateikimas',
  noTaxInformationIsAvailable: 'Mokesčių informacijos nėra',
  retryPullTaxInformation: 'Atnaujinkite mokesčių duomenis',
  var: '% Var',
  designQTY: 'Dizainas Kiekis',
  batched: 'Supakuota',
  moisture: 'Drėgmė',
  actualWater: 'Tikrasis vanduo',
  moisturePercent: '% drėgmės',
  freeWater: 'Nemokamas vanduo',
  reset: 'Nustatyti iš naujo',
  'at-plant': 'Prie gamyklos',
  'at-job': 'Darbe',
  viewTickets: 'Žiūrėti bilietus',
  viewSchedule: 'Žiūrėti tvarkaraštį',
  viewActiveTicket: 'Žiūrėti aktyvų bilietą',
  dateSelector_last_week: 'Paskutinės 7 dienos',
  dateSelector_yesterday: 'vakar',
  dateSelector_tomorrow: 'Rytoj',
  dateSelector_today: 'Šiandien',
  gridHeader_created: 'Sukurta',
  gridHeader_customerStatus: 'Kliento būsena',
  gridHeader_ticketId: 'Bilietas',
  gridHeader_vehicle: 'Transporto priemonė',
  gridFooter_retrieved: 'Paimta',
  gridFooter_loading: 'Įkeliama...',
  general: {
    ...CAI_MATERIAL.i18n['en-US'].general,
  },
  component: {
    ...CAI_MATERIAL.i18n['en-US'].component,
  },
  attachments: 'Priedai',
  priorOrderCostTotal: 'Iš viso',
  priorOrderPaymentTotal: 'Išankstiniai mokėjimai',
  orderShippedCostTotal: 'Užsakymo suma',
  orderShippedBalance: 'Užsakymo likutis',
  ticketSubtotal: 'Bilietų tarpinė suma',
  ticketTax: 'Bilieto mokestis',
  ticketTotal: 'Iš viso bilietų',
  driverId: 'Vairuotojo ID',
  ticketStatus: 'Bilieto būsena',
  voided: 'Anuliuota',
  ticketVoidedNotification: 'Šis bilietas buvo anuliuotas.',
  ticketed: 'Bilietas',
};
